export default __webpack_public_path__ + "images/8b3d2f1bd74b357b29291d28a9930474-sports.webp";